/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OfferNoteAttachmentDownloadUrlResponse } from '../../models/offer-note-attachment-download-url-response';

export interface GetOfferNoteAttachmentDownloadUrl$Params {
  id: number;
  noteEntryId: number;
  attachmentId: number;
}

export function getOfferNoteAttachmentDownloadUrl(http: HttpClient, rootUrl: string, params: GetOfferNoteAttachmentDownloadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferNoteAttachmentDownloadUrlResponse>> {
  const rb = new RequestBuilder(rootUrl, getOfferNoteAttachmentDownloadUrl.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('noteEntryId', params.noteEntryId, {});
    rb.path('attachmentId', params.attachmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OfferNoteAttachmentDownloadUrlResponse>;
    })
  );
}

getOfferNoteAttachmentDownloadUrl.PATH = '/offers/{id}/note-entries/{noteEntryId}/attachments/{attachmentId}/download-url';
